module.exports = "<i class=\"spark-icon--fill spark-icon-check-circle circle-check-icon\" data-click=true uid={{uid}} field-id={{fieldId}}></i>";